class LocalStorage {
	constructor () {
		this.myLocalStorage = window.localStorage
	}

	getItem (key) {
		return this.myLocalStorage.getItem(key)
	}

	setItem (key, value) {
		return this.myLocalStorage.setItem(key, value)
	}

	removeItem (key) {
		return this.myLocalStorage.removeItem(key)
	}
}

export default new LocalStorage()



// WEBPACK FOOTER //
// ./src/common/services/local-storage.js